import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import it from './locales/it.json';

// Recupero lingua dal localStorage o default su 'en'
const defaultLanguage = 'en'; // Lingua predefinita
// const savedLanguage = localStorage.getItem('lang') || defaultLanguage;
const savedLanguage = sessionStorage.getItem('lang') || defaultLanguage;

// Configurazione i18n
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en, // Traduzioni per l'inglese
    },
    it: {
      translation: it, // Traduzioni per l'italiano
    },
  },
  lng: savedLanguage, // Lingua iniziale
  fallbackLng: defaultLanguage, // Lingua di fallback
  interpolation: {
    escapeValue: false, // React gestisce automaticamente XSS
  },
});

// Salvare la lingua nel localStorage quando cambia (opzionale)
i18n.on('languageChanged', (lng) => {
   
  // localStorage.setItem('lang', lng);
  sessionStorage.setItem('lang', lng);

  
});

export default i18n;
